import ReactDOM from "react-dom";
import { ButtonStyle } from "../../js/enums";
import Button from "./Button";
import Modal from "./Modal";

function HelperModal({
  closeText = "Close",
  children,
  modalTitle,
  onClose,
  wrapperCustomClassName,
}) {
  const modalRoot = document.getElementById("modal-root");

  return !modalRoot ? (
    <></>
  ) : (
    <>
      {ReactDOM.createPortal(
        <Modal
          title={modalTitle}
          modalCloseButtonClick={onClose}
          wrapperCustomClassName={wrapperCustomClassName}
        >
          <div className="modal-body">{children}</div>
          <div className="modal-footer">
            <div className="w-100 d-flex justify-content-end">
              <Button
                onClick={onClose}
                style={ButtonStyle.Info}
                text={closeText}
              />
            </div>
          </div>
        </Modal>,
        modalRoot
      )}
    </>
  );
}

export default HelperModal;
